var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Stack, Text } from "native-base";
const HorizontalListItem = (_a) => {
    var { label, content } = _a, rest = __rest(_a, ["label", "content"]);
    return (_jsxs(Stack, Object.assign({ direction: "row", justifyContent: "space-between", alignItems: "center", bgColor: "white", p: 4, minWidth: "full" }, rest, { children: [_jsx(Text, Object.assign({ color: "gray.600", fontSize: "xs" }, { children: label })), _jsx(Text, Object.assign({ fontSize: "xs", fontWeight: "medium", textAlign: "right" }, { children: content !== null && content !== void 0 ? content : "-" }))] })));
};
export default HorizontalListItem;
